import { useEffect as e } from "react";
import { ErrorReporterRegistry as t } from "@maat/store-error";
//#region src/react/useSyncErrorReporterUser.ts
function n(n) {
	let r = n?.userId, i = n?.sessionId, a = n?.role;
	e(() => {
		t.tryGet()?.setUser({
			userId: r,
			sessionId: i,
			role: a
		});
	}, [
		r,
		i,
		a
	]);
}
//#endregion
export { n as useSyncErrorReporterUser };
